import React, { useState } from 'react';
import img from "../../images/2761015.svg";
import {Link} from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";
import LanguageSwitcher from "../../Components/languageswitcher/LanguageSwitcher";
import OffertaRu from "../../Components/offerta/OffertaRu";
import OffertaUz from "../../Components/offerta/OffertaUz";

const SignUp = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        passwordConfirm: '',
        agreement: false,
        production: false,
    });
    const register = async (credentials) => {
        return axios.post(
            process.env.REACT_APP_API_ENDPOINT+'/app/signup',
            credentials,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        )
            .then(response => {
                return response;
            })
            .catch(err => {
                return err.response;
            });
    }
    const [showModal, setShowModal] = useState(false);
    const [touched, setTouched] = useState({});

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched((prev) => ({ ...prev, [name]: true }));
    };

    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const isStrongPassword = (password) =>
        password.length >= 6;

    const isFormValid = () =>
        isValidEmail(formData.email) &&
        isStrongPassword(formData.password) &&
        formData.password === formData.passwordConfirm &&
        formData.agreement;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid()) {
            alert(t('fill_out'));
            return;
        }
        const response = await register(formData);
        console.log('rrr',response)
        if (response?.data?.success) {
            swal(t('success'), t('registered'), "success", {
                buttons: false,
                timer: 2000,
            })
                .then(() => {
                    window.location = '/login';
                });
        } else {
            const message = response?.data?.message;
            let firstError = t('saving_error');

            if (message && typeof message === 'object') {
                const firstKey = Object.keys(message)[0];
                if (firstKey && Array.isArray(message[firstKey])) {
                    firstError = message[firstKey][0];
                }
            }
            swal(t('error'), firstError, "error");
            // throw new Error(firstError);
        }
    };

    return (
        <div className="container d-flex">
            <div className="site-login">
                <div className="title d-flex align-items-center gap-2">
                    <img src={img} alt="icon" />
                    <h2 className="text-uppercase">- {t('sign_up')} -</h2>
                </div>

                <form id="form-signup" onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label" htmlFor="email">
                            <span className="text-danger">*</span> {t('email')}
                        </label>
                        <input
                            type="email"
                            id="email"
                            className={`form-control ${touched.email && !isValidEmail(formData.email) ? 'is-invalid' : ''}`}
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                        />
                        {touched.email && !isValidEmail(formData.email) && (
                            <div className="invalid-feedback">{t('valid_email')}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label className="form-label" htmlFor="password">
                            <span className="text-danger">*</span> {t('insert_pwd')}
                        </label>
                        <input
                            type="password"
                            id="password"
                            className={`form-control ${touched.password && !isStrongPassword(formData.password) ? 'is-invalid' : ''}`}
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                        />
                        {touched.password && !isStrongPassword(formData.password) && (
                            <div className="invalid-feedback">{t('min_pwd')}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label className="form-label" htmlFor="passwordConfirm">
                            <span className="text-danger">*</span> {t('re_enter_pwd')}
                        </label>
                        <input
                            type="password"
                            id="passwordConfirm"
                            className={`form-control ${touched.passwordConfirm && formData.password !== formData.passwordConfirm ? 'is-invalid' : ''}`}
                            name="passwordConfirm"
                            value={formData.passwordConfirm}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                        />
                        {touched.passwordConfirm && formData.password !== formData.passwordConfirm && (
                            <div className="invalid-feedback">{t('pwd_not_match')}.</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                id="agreement"
                                className="form-check-input"
                                name="agreement"
                                checked={formData.agreement}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                required
                            />
                            <label className="form-check-label" htmlFor="agreement">
                                <p>
                                    {t('i_have_read')}{' '}
                                    <i
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowModal(true);
                                        }}
                                        style={{textDecoration: 'underline', cursor: 'pointer'}}
                                    >
                                        {t('public_offer')}
                                    </i>
                                    {t('i_have_read_uz')}
                                </p>
                            </label>
                        </div>
                        {!formData.agreement && touched.agreement && (
                            <div className="text-danger small mt-1">{t('accept_offer')}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                id="production"
                                className="form-check-input"
                                name="production"
                                checked={formData.production}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="production">
                                {t('local_production')}
                            </label>
                        </div>
                    </div>

                    <div className="form-group d-grid gap-2 mt-4">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={!isFormValid()}
                        >
                            {t('sign_up')}
                        </button>
                    </div>
                </form>

                {showModal && (
                    currentLang === 'ru'
                        ? <OffertaRu onClose={() => setShowModal(false)} />
                        : <OffertaUz onClose={() => setShowModal(false)} />
                )}
                <div className="text-center p-2 mt-2">
                    <Link className="link1" to="/login">
                        {t('login')}
                    </Link>
                </div>
                <br/>
                <LanguageSwitcher />
            </div>
        </div>
    );
};

export default SignUp;
